import { render } from "./AttendanceListView.vue?vue&type=template&id=0fd28e04"
import script from "./AttendanceListView.vue?vue&type=script&lang=js"
export * from "./AttendanceListView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__